export class JobProgressStepUserDataRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoredObjectId",
            "baseName": "restoredObjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPrincipalName",
            "baseName": "userPrincipalName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepUserDataRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
